import Icon from 'components/Icon';
import React, {FC} from 'react';
import style from './style.module.scss';

export const ListVisualProductCardFnR: FC = () => {
    return (
        <div className={style.main}>
            <Icon className={style.icon} icon={'fineandrare'} />
        </div>
    );
};
